/**
 * Collapsible text (keynote speaker bio): the `bio` ref is clamped by CSS
 * max-height; the toggle button only shows when the text actually overflows.
 */
export default () => ({
  open: false,
  overflow: false,

  init() {
    this.$nextTick(() => this.measure());
    if (document.fonts) {
      document.fonts.ready.then(() => this.measure());
    }
    window.addEventListener('resize', () => {
      if (!this.open) {
        this.measure();
      }
    });
  },

  measure() {
    const bio = this.$refs.bio;
    if (!bio) {
      return;
    }
    this.overflow = bio.scrollHeight > bio.clientHeight + 1;
  },

  toggle() {
    const bio = this.$refs.bio;
    if (this.open) {
      bio.style.maxHeight = `${bio.scrollHeight}px`;
      void bio.offsetWidth;
      bio.style.maxHeight = '';
      this.open = false;
    } else {
      bio.style.maxHeight = `${bio.scrollHeight}px`;
      this.open = true;
      const onTransitionEnd = (e) => {
        if (e.target !== bio || e.propertyName !== 'max-height') {
          return;
        }
        bio.removeEventListener('transitionend', onTransitionEnd);
        if (this.open) {
          bio.style.maxHeight = 'none';
        }
      };
      bio.addEventListener('transitionend', onTransitionEnd);
    }
  },
});
